import { getSearchSuggestionOptionId } from './get-search-suggestion-option-id';

export const getSuggestionOptionAriaProps = (elementIndex: number, navigationIndex: number) => ({
  id: getSearchSuggestionOptionId(elementIndex),
  role: 'option' as const,
  'aria-selected': elementIndex === navigationIndex,
});
